import {i18n} from '@/utils/i18n';

export const rules = {
    deal_id: [{ required: true, message: i18n.t('message.please_select_input', {input: i18n.t('message.deal')}), trigger: "change" }],
    product_id: [{ required: true, message: i18n.t('message.please_select_input', {input: i18n.t('message.product')}), trigger: "change" }],
    price: [{ required: true, message: i18n.t('message.please_enter_input', {input: i18n.t('message.price')}), trigger: "change" }],
    currency_rate: [{ required: true, message: i18n.t('message.please_enter_input', {input: i18n.t('message.rate')}), trigger: "change" }],
    quantity: [{ required: true, message: i18n.t('message.please_enter_input', {input: i18n.t('message.quantity')}), trigger: "change" }],
};
